export default function queryNode(_ref) {
  var type = _ref.type,
      media = _ref.media,
      support = _ref.support;
  var targetDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var mediaQuery = media ? "[media=\"".concat(media, "\"]") : ':not([media])';
  var supportQuery = support ? '[data-fela-support="true"]' : ':not([data-fela-support="true"])';
  return targetDocument.querySelector("[data-fela-type=\"".concat(type, "\"]").concat(supportQuery).concat(mediaQuery));
}